import { Calendar, Globe, Video } from "lucide-react";
import hoopsHeroBg from "@/assets/hoops-hero-bg.png";

export function HoopsNetwork() {
  return (
    <section className="py-32 md:py-40 relative overflow-hidden">
      {/* Background image with blue overlay */}
      <div className="absolute inset-0">
        <img
          src={hoopsHeroBg}
          alt="RecruitLook Hoops basketball game background"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-slate-900/70" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-3 gap-6 items-stretch">
          {/* Left yellow panel */}
          <div className="bg-secondary text-slate-900 rounded-2xl p-8 shadow-xl h-full">
            <h3 className="text-2xl sm:text-3xl font-black mb-4 leading-tight">RecruitLook Hoops Network</h3>
            <p className="text-slate-900/90 font-medium">
              Our ecosystem powers exposure and recruiting: national events, real coverage, a modern web platform, and a growing international footprint.
            </p>
            <img
              src="https://cdn.builder.io/api/v1/image/assets%2F7b5b7573f41a45539311717edd1f85db%2F6cd4b4df1ebb4c0e962b727ff74e1359?format=webp&width=512"
              alt="RecruitLook Hoops"
              className="mt-6 h-14 sm:h-16 w-auto object-contain"
            />
          </div>

          {/* Column 2: Events + Coverage stacked */}
          <div className="grid grid-rows-2 gap-6 h-full">
            <div className="rounded-2xl bg-slate-900/70 text-white p-8 shadow-xl border border-white/10 h-full transition-colors duration-200 hover:bg-slate-900/90">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-lg bg-transparent text-secondary flex items-center justify-center">
                  <Calendar className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-black tracking-tight">Events</h4>
              </div>
              <p className="text-white/80">HS Boys Circuit, Youth Circuit, Girls Tournaments, Elite Camps</p>
            </div>
            <div className="rounded-2xl bg-slate-900/70 text-white p-8 shadow-xl border border-white/10 h-full transition-colors duration-200 hover:bg-slate-900/90">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-lg bg-transparent text-secondary flex items-center justify-center">
                  <Video className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-black tracking-tight">Coverage</h4>
              </div>
              <p className="text-white/80">Live streams, highlights, graphics, social reach</p>
            </div>
          </div>

          {/* Column 3: Website + International stacked */}
          <div className="grid grid-rows-2 gap-6 h-full">
            <div className="rounded-2xl bg-slate-900/70 text-white p-8 shadow-xl border border-white/10 h-full transition-colors duration-200 hover:bg-slate-900/90">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-lg bg-transparent text-secondary flex items-center justify-center">
                  <Globe className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-black tracking-tight">Website</h4>
              </div>
              <p className="text-white/80">Articles, roster openings, camp listings, AI tools</p>
            </div>
            <div className="rounded-2xl bg-slate-900/70 text-white p-8 shadow-xl border border-white/10 h-full transition-colors duration-200 hover:bg-slate-900/90">
              <div className="flex items-center gap-3 mb-2">
                <div className="w-10 h-10 rounded-lg bg-transparent text-secondary flex items-center justify-center">
                  <Globe className="w-6 h-6" />
                </div>
                <h4 className="text-xl font-black tracking-tight">International</h4>
              </div>
              <p className="text-white/80">USA, Canada, Serbia, Australia — expanding to England</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
